import root from 'window-or-global';

import { createStore, combineReducers, applyMiddleware } from 'redux';
import reduxLogger from 'redux-logger';
import { reducers } from './reducers';
import { copyObject, isDebugMode } from './utils';


const jobsReducers = combineReducers({
  jobs: reducers
});

let store;

// Grab the state from a global variable injected into the server-generated HTML
let preloadedState;

if (typeof window !=='undefined') {
  preloadedState = window.__PRELOADED_STATE__;
  console.log('store', preloadedState);
  // Allow the passed state to be garbage-collected
  // to be removed at a later stage
  // delete window.__PRELOADED_STATE__;
}

if (root.document && isDebugMode()) {
    store = createStore(jobsReducers, preloadedState, applyMiddleware(reduxLogger));
} else {
    store = createStore(jobsReducers, preloadedState);
}

export default store;

export class JobStore {
    static getState = () => copyObject(store.getState().jobs);
    static dispatch = params => store.dispatch(params);
    static storeHasKey = (...args) => {
        let obj = JobStore.getState();

        for (let i = 0; i < args.length; i++) {
            if (!obj || !obj.hasOwnProperty(args[i])) {
                return false;
            }
            obj = obj[args[i]];
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ../q-jobs/src/store.js